import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Footer() {
  const [content, setContent] = useState(null);
  const { settings } = useSiteSettings();
  useEffect(() => {
    api.get("/site-content").then(({ data }) => setContent(data?.footer)).catch(() => {});
  }, []);

  const links = content?.links || [
    { label: "How it works", href: "/how-it-works" },
    { label: "Demos", href: "/demos" },
    { label: "Solutions", href: "/solutions" },
    { label: "Consultation", href: "/consultation" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <footer className="bg-zinc-950 text-zinc-300" data-testid="site-footer">
      <div className="app-container py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-5">
            <img src="/appistry-logo.png" alt="Appistry" className="h-10 w-10 object-contain" />
            <span className="text-xl font-bold tracking-tight text-white" style={{ fontFamily: "'Outfit', sans-serif" }}>Appistry</span>
          </div>
          <p className="text-zinc-400 max-w-sm">
            Practical apps, thoughtfully built. Small, sharp tools that remove real friction from your business.
          </p>
          <div className="mt-8 overline text-zinc-500">Contact</div>
          <a href={`mailto:${content?.contact_email || "hello@appistry.tech"}`} className="text-white font-medium mt-2 inline-block" data-testid="footer-email">
            {content?.contact_email || "hello@appistry.tech"}
          </a>
          <p className="text-sm text-zinc-500 mt-2">{content?.address || "Remote-first — UK / EU"}</p>
        </div>

        <div className="md:col-span-4 md:col-start-8">
          <div className="overline text-zinc-500 mb-4">Explore</div>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l.href}>
                <Link to={l.href} className="text-zinc-300 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
            {settings.co_innovation_enabled && (
              <li>
                <Link to="/co-innovation" className="text-[hsl(var(--appistry-signal))] hover:text-white transition-colors font-medium" data-testid="footer-coinnovation">
                  ★ Co-innovation programme
                </Link>
              </li>
            )}
            <li>
              <Link to="/admin/login" className="text-zinc-500 hover:text-white text-sm font-mono transition-colors" data-testid="footer-admin">
                Admin
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800 py-6">
        <div className="app-container flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-zinc-500 font-mono">© {new Date().getFullYear()} Appistry. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/privacy" className="text-xs text-zinc-500 hover:text-white font-mono transition-colors" data-testid="footer-privacy">Privacy</Link>
            <Link to="/terms" className="text-xs text-zinc-500 hover:text-white font-mono transition-colors" data-testid="footer-terms">Terms</Link>
            <p className="text-xs text-zinc-500 font-mono hidden md:block">Practical apps, thoughtfully built.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
